<template>
	<section class="wysiwyg">
		<div
			class="anchor"
			:id="section_id"
		></div>
		<div class="container">
			<div
				class="wysiwyg__inner"
				:class="{'top_border': top_border}"
			>
				<span
					v-html="wysiwyg"
					class="body"
				></span>

				<div
					class="cta_wrapper"
					v-if="parsedPrimaryCta || parsedSecondaryCta"
				>
					<primary-button
						v-if="parsedPrimaryCta"
						:label="parsedPrimaryCta.title"
						:link="parsedPrimaryCta"
						:theme="primary_cta_theme ? primary_cta_theme : 'dark'"
					></primary-button>
					<secondary-button
						v-if="parsedSecondaryCta"
						:label="parsedSecondaryCta.title"
						:link="parsedSecondaryCta"
						:theme="secondary_cta_theme ? secondary_cta_theme : 'light'"
					></secondary-button>
				</div>

			</div>

		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';

export default {
	data() {
		return {};
	},

	props: {
		section_id: {},
		top_border: {},
		wysiwyg: {},
		primary_cta: {},
		primary_cta_theme: {},
		secondary_cta: {},
		secondary_cta_theme: {},
	},

	computed: {
		parsedPrimaryCta() {
			if (this.primary_cta) {
				return JSON.parse(this.primary_cta);
			} else {
				return null;
			}
		},

		parsedSecondaryCta() {
			if (this.secondary_cta) {
				return JSON.parse(this.secondary_cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {
		PrimaryButton,
		SecondaryButton,
	},

	created() {},
	mounted() {
		let wysiwygIcons = document.querySelectorAll('.wysiwyg_icon');

		wysiwygIcons.forEach((element) => {
			window.onscroll = function () {
				var theta = (document.documentElement.scrollTop / 100) % Math.PI;

				element.style.transform = 'rotate(' + theta + 'rad)';
			};
		});
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/RichText.vue